var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#58BE92",
    d: "M15.978 7.813c-.588-1.504-2.075-1.641-3.81-1.299l-.613-2.164l-1.316.382l.604 2.087l-1.045.317l-.605-2.113l-1.303.381l.613 2.143l-.835.257V7.8l-1.805.514l.399 1.398s.964-.3.956-.275c.527-.154.788.107.917.36l.703 2.447l.141-.021l-.141.038l.985 3.438c.026.171 0 .463-.364.57c.017.008-.956.278-.956.278l.189 1.637l1.701-.488l.943-.262l.626 2.173l1.298-.377l-.608-2.147l1.046-.291l.612 2.142l1.316-.377L15 16.384c2.165-.758 3.549-1.757 3.15-3.878c-.325-1.706-1.324-2.229-2.657-2.165c.643-.612.922-1.422.493-2.528zm-.489 5.186c.459 1.628-2.374 2.237-3.257 2.498l-.827-2.884c.887-.257 3.595-1.307 4.084.386m-1.774-3.905c.42 1.488-1.955 1.976-2.696 2.19l-.75-2.614c.741-.21 3-1.114 3.446.433z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBch);
export default __webpack_public_path__ + "static/media/bch.a17a8b0f3635d96b2cc77bb10a5d60d2.svg";
export { ForwardRef as ReactComponent };